module.exports = "<div class=\"form-container\">\n  <form #formData='ngForm' (ngSubmit)='onSubmit(formData)'>\n    <input type=\"text\" placeholder=\"Email\" [(ngModel)]=\"email\" name=\"email\" class=\"input-txt\" required>\n    <input type=\"password\" placeholder=\"Senha\" [(ngModel)]=\"password\" name=\"password\" class=\"input-txt\" required>\n    <button type=\"submit\" [disabled]=\"!formData.valid\" class=\"btn btn-primary\">Entrar</button>\n  </form>\n  <br>\n  <a routerLink=\"/signup\">Novo usuário? Criar Conta</a>\n  <br>\n  \n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/email/email.component.html
// module id = ./src/app/email/email.component.html
// module chunks = main